// removed by extract-text-webpack-plugin
module.exports = {"errorBody":"src-components-ErrorPage-___ErrorPage__errorBody___2aWI8","errorMessage":"src-components-ErrorPage-___ErrorPage__errorMessage___2cDrc","errorLink":"src-components-ErrorPage-___ErrorPage__errorLink___CNWvj","errorDetails":"src-components-ErrorPage-___ErrorPage__errorDetails___2ZHWC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ErrorPage/ErrorPage.css
// module id = 475
// module chunks = 3